import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute';
import Home from './routes/Home'
import Login from './routes/Login'
import Events from './routes/Events'
import './App.css';

function App() {
  return (
    <Router>
      <Switch>
      <Route exact path="/home" component={Home} />
      <PrivateRoute exact path="/events" component={Events} />
      <Route exact path="/login" component={Login} />
      <Route path="/" component={Home}/>
      </Switch>
    </Router>
  );
}

export default App;
